import { Subject } from 'rxjs';

// Remember to update data-layer.ts every time a change to the content of this data occurs.
export let dataLayerDetails: any[] = [
	{ 'dataType': 'allStations',
		'dataTypeName': 'All',
		'value': null,
		'valueObservable': new Subject<any>(),
		'valueObserver': null,
		'title': 'change',
		'novaScore': null,
		'novaScoreDescriptions': null,
		'units': null,
		'capacity': 'capacity',
		'capacityUnits': 'capacityUnits',
		'tsFileEnding': '',
		'tsFileExtension': 'json',
		'stationID': 'numId',
		'stationName': 'name',
		'color': 'green',
		'shape': 'square',
		'mapLayer': null,
		'special1': null,
		'special2': null,
		'special3': null,
		'special4': null,
		'active': false
	},
	{ 'dataType': 'streamFlowStations',
		'dataTypeName': 'Streamflow',
		'value': null,
		'valueObservable': new Subject<any>(),
		'valueObserver': null,
		'title': 'dischargeRiverTitle',
		'novaScore': 'dischargeRiverNovaScore',
		'novaScoreDescriptions': null,
		'units': null,
		'capacity': 'capacity',
		'capacityUnits': 'capacityUnits',
		'tsFileEnding': '-Flow-Irregular',
		'tsFileExtension': 'json',
		'stationID': 'numId',
		'stationName': 'name',
		'color': 'green',
		'shape': 'square',
		'mapLayer': null,
		'special1': null,
		'special2': null,
		'special3': null,
		'special4': null,
		'active': false
	},
	{ 'dataType': 'waterLevelStations',
		'dataTypeName': 'Stage',
		'value': null,
		'valueObservable': new Subject<any>(),
		'valueObserver': null,
		'title': 'waterLevelRiverTitle',
		'novaScore': 'waterLevelRiverNovaScore',
		'novaScoreDescriptions': null,
		'units': null,
		'capacity': 'capacity',
		'capacityUnits': 'capacityUnits',
		'tsFileEnding': '-WaterLevel-Irregular',
		'tsFileExtension': 'json',
		'stationID': 'numId',
		'stationName': 'name',
		'color': 'blue',
		'shape': 'square',
		'mapLayer': null,
		'special1': null,
		'special2': null,
		'special3': null,
		'special4': null,
		'active': false
	},
	{ 'dataType': 'precipStations',
		'dataTypeName': 'Precipitation',
		'value': null,
		'valueObservable': new Subject<any>(),
		'valueObserver': null,
		'title': 'precipTitle',
		'novaScore': 'precipNovaScore',
		'novaScoreDescriptions': null,
		'units': null,
		'capacity': 'capacity',
		'capacityUnits': 'capacityUnits',
		'tsFileEnding': '-Precip-',
		'tsFileExtension': 'json',
		'stationID': 'numId',
		'stationName': 'name',
		'color': 'cyan',
		'shape': 'square',
		'mapLayer': null,
		'special1': null,
		'special2': null,
		'special3': null,
		'special4': null,
		'active': false
	},
	{ 'dataType': 'addnlData',
		'dataTypeName': 'variable',
		'value': null,
		'valueObservable': new Subject<any>(),
		'valueObserver': null,
		'title': 'bonusTitle',
		'novaScore': 'bonusNovaScore',
		'novaScoreDescriptions': null,
		'units': null,
		'capacity': 'capacity',
		'capacityUnits': 'capacityUnits',
		'tsFileEnding': '',
		'tsFileExtension': 'json',
		'stationID': 'numId',
		'stationName': 'name',
		'color': 'cyan',
		'shape': 'square',
		'mapLayer': null,
		'special1': null,
		'special2': null,
		'special3': null,
		'special4': null,
		'active': false
	},
	{ 'dataType': 'fitAssets',
		'dataTypeName': 'Flood Impact',
		'value': null,
		'valueObservable': new Subject<any>(),
		'valueObserver': null,
		'title': 'capacity',
		'novaScore': null,
		'novaScoreDescriptions': null,
		'units': null,
		'capacity': 'capacity',
		'capacityUnits': 'capacityUnits',
		'tsFileEnding': '-Precip-',
		'tsFileExtension': 'json',
		'stationID': 'id',
		'stationName': 'name',
		'color': 'blue-dark',
		'shape': 'square',
		'mapLayer': null,
		'special1': 'assetType',
		'special2': 'capacity',
		'special3': 'basinName',
		'special4': 'upstreamStationId',
		'active': false
	},
	{ 'dataType': 'fitAssetsGeoJSON',
		'dataTypeName': 'Flood Impact',
		'value': null,
		'valueObservable': new Subject<any>(),
		'valueObserver': null,
		'title': 'fitTitle',
		'novaScore': 'fitNovaScore',
		'novaScoreDescriptions': null,
		'units': null,
		'capacity': 'capacity',
		'capacityUnits': 'capacityUnits',
		'tsFileEnding': '-Precip-',
		'tsFileExtension': 'json',
		'stationID': 'id',
		'stationName': 'name',
		'color': 'blue-dark',
		'shape': 'penta',
		'mapLayer': null,
		'special1': 'assetType',
		'special2': 'capacity',
		'special3': 'basinName',
		'special4': 'upstreamStationId',
		'active': false
	},
	{ 'dataType': 'cameraStations',
		'dataTypeName': 'Camera',
		'value': null,
		'valueObservable': new Subject<any>(),
		'valueObserver': null,
		'title': 'name',
		'novaScore': null,
		'novaScoreDescriptions': null,
		'units': null,
		'capacity': 'capacity',
		'capacityUnits': 'capacityUnits',
		'tsFileEnding': '-Precip-',
		'tsFileExtension': 'json',
		'stationID': 'name',
		'stationName': 'name',
		'color': 'yellow',
		'shape': 'square',
		'mapLayer': null,
		'special1': 'link',
		'special2': 'image',
		'special3': 'image_height',
		'special4': 'image_width',
		'active': false
	},
	{ 'dataType': 'floodplain',
		'dataTypeName': 'Floodplain',
		'value': null,
		'valueObservable': new Subject<any>(),
		'valueObserver': null,
		'title': 'name',
		'novaScore': null,
		'novaScoreDescriptions': null,
		'units': null,
		'capacity': '',
		'capacityUnits': '',
		'tsFileEnding': '',
		'tsFileExtension': '',
		'stationID': '',
		'stationName': '',
		'color': 'yellow',
		'shape': 'square',
		'mapLayer': null,
		'special1': '',
		'special2': '',
		'special3': '',
		'special4': '',
		'active': false
	},
	{ 'dataType': 'radar',
		'dataTypeName': 'Radar',
		'value': '',
		'valueObservable': new Subject<any>(),
		'valueObserver': null,
		'title': '',
		'novaScore': null,
		'novaScoreDescriptions': null,
		'units': null,
		'capacity': '',
		'capacityUnits': '',
		'tsFileEnding': '',
		'tsFileExtension': '',
		'stationID': '',
		'stationName': '',
		'color': '',
		'shape': '',
		'mapLayer': null,
		'special1': '',
		'special2': '',
		'special3': '',
		'special4': '',
		'active': false
	},
	{ 'dataType': 'weatherWarnings',
		'dataTypeName': 'Weather',
		'value': '',
		'valueObservable': new Subject<any>(),
		'valueObserver': null,
		'title': '',
		'novaScore': null,
		'novaScoreDescriptions': null,
		'units': null,
		'capacity': '',
		'capacityUnits': '',
		'tsFileEnding': '',
		'tsFileExtension': '',
		'stationID': '',
		'stationName': '',
		'color': 'yellow',
		'shape': 'square',
		'mapLayer': null,
		'special1': '',
		'special2': '',
		'special3': '',
		'special4': '',
		'active': false
	}
];
